module.exports = require("core-js/library/fn/array/from");


//////////////////
// WEBPACK FOOTER
// ../node_modules/@babel/runtime/core-js/array/from.js
// module id = 53
// module chunks = 0 1 2 4